declare global {
    interface Window {
        deployConfig?: { bffURL?: string };
    }
}

export const urlResolve = (): string => {
    if (window.deployConfig?.bffURL) {
        return window.deployConfig.bffURL;
    }
    return window.location.origin;
};
